<template>
  <Accordion title="Dados do Depósito">
    <div class="grid grid-cols-4 gap-3">
      <Select v-if="!routeInfo.params.id" :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputText :disabled="disabled" v-model="localValue.name" label="Nome do Depósito" :error="localErrors.name" required placeholder="Insira o Nome do Depósito" />
      <InputZoom
        :disabled="disabled"
        required
        clearable
        v-model="localValue.idSource"
        label="Equipe"
        :error="localErrors.idSource || localErrors.duplicateEntry"
        database="team"
        item-text="name"
        itemAutocomplete="id"
        item-value="id"
        :filter="computedFilterTeam"
        placeholder="Selecione a equipe" />
      <InputZoom disabled v-model="localValue.leader" label="Líder" database="employee" item-text="name" item-value="id" placeholder="Selecione o líder" />
      <InputZoom
        :disabled="disabled"
        label="Localidade"
        database="local"
        item-text="name"
        :error="localErrors.idLocal"
        clearable
        item-value="id"
        v-model="localValue.idLocal"
        placeholder="Selecione a localidade" />
      <TextArea :disabled="disabled" class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira a descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch, onMounted, computed } from 'vue'
import { get } from '@/crud'
import { useRoute, useRouter } from 'vue-router'

const router = useRoute()
const routeInfo = useRoute()

const type = [
  { label: 'Físico', value: 'physic' },
  { label: 'Equipe', value: 'team' },
  { label: 'Veículo', value: 'vehicles' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const warehousesExist = ref([])

const computedFilterTeam = computed(() => {
  return [
    {
      column: 'id',
      value: warehousesExist.value,
      operator: 'is not in',
    },
  ]
})

const loadItem = async (route, id) => {
  const filters = [{ column: 'id', value: id, operator: '=' }]

  const query = {
    params: {
      filters,
    },
  }

  const raw = await get(route, query)

  if (raw.data.length) {
    localValue.leader = raw.data[0]?.leader
  }
}

const loadWarehouses = async () => {
  const filters = [{ column: 'type', operator: '=', value: 'team' }]
  const query = {
    params: {
      filters,
    },
  }

  const raw = await get('warehouse', query)

  warehousesExist.value = raw.data.map((el) => el.idSource)
}

onMounted(async () => {
  if (localValue.idSource) {
    await loadItem('team', localValue.idSource)
  }
  await loadWarehouses()
})

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(
  () => localValue.idSource,
  async (newVal) => {
    localValue.leader = null
    if (newVal) {
      await loadItem('team', newVal)
      await loadWarehouses()
    }
  },
)
</script>
